<template>
    <div 
      class="tab-pane fade" 
      :class="{ 'show active': isActive }"
      :id="id" 
      role="tabpanel" 
      :aria-labelledby="`${id}-tab`"
    >
      <slot></slot>
    </div>
  </template>
  
  <script setup>
  import { computed, inject, onMounted } from 'vue';
  
  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    isInitialActive: {
      type: Boolean,
      default: false
    }
  });
  
  const activeTabId = inject('activeTabId', ref(''));
  
  const isActive = computed(() => {
    return activeTabId.value === props.id;
  });
  
  onMounted(() => {
    if (props.isInitialActive) {
      activeTabId.value = props.id;
    }
  });
  </script>